import { render, staticRenderFns } from "./TranshipmentEvaluations.vue?vue&type=template&id=872eba10&scoped=true"
import script from "./TranshipmentEvaluations.vue?vue&type=script&lang=js"
export * from "./TranshipmentEvaluations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872eba10",
  null
  
)

export default component.exports